import React from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import api from '../../../../../components/api';

function useRenderVmCard(refetch: () => void) {
  // Show and hide more vm handler
  const [show, setShow] = React.useState<boolean>(false);
  const handleShow = () => setShow(!show);

  // Delete VM and modal handler
  const [resultDeleteVM, setResultDeleteVM] = React.useState();
  const { isLoading: loadingDeleteVM, mutate: deleteVM } = useMutation(api.vendingMachine.deleteById, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res: any) => {
      console.log(res);
      setResultDeleteVM(res);
    },
    onError: (err: any) => {
      console.log('err', err);
      setResultDeleteVM(err);
    },
  });
  const handleDeleteVM = (id: string) => {
    deleteVM(id);
  };
  const onAfterDelete = () => {
    refetch();
    setResultDeleteVM(undefined);
  };

  // Navigation Handler
  const navigation = useNavigate();
  // Navigation to Planogram By Id
  const onNavigateToPlanogram = (vmId: string) => navigation(`planogram/${vmId}`);

  const onNavigateToDex = (vmId: string) => navigation(`dex/${vmId}`);

  return {
    modal: {
      result: resultDeleteVM,
      loading: loadingDeleteVM,
      handler: handleDeleteVM,
      after: onAfterDelete,
    },
    show: {
      current: show,
      handler: handleShow,
    },
    onNavigateToPlanogram,
    onNavigateToDex,
  };
}

export default useRenderVmCard;
